import { ui } from 'modules/common';
import { useCallback, useMemo } from 'react';

import { SelectTimeProps } from './SelectTime.types';

const options = ui.allTimeReferences;

export const useSelectTime = (time: SelectTimeProps['time'], onChange: SelectTimeProps['onChange']) => {
    const value = useMemo(() => {
        if (!time) {
            return undefined;
        }

        return options.find((option) => option.hours === time.hour && option.minutes === time.minute)?.id;
    }, [time]);

    const handleChange = useCallback(
        (valueNext: string) => {
            onChange(valueNext, options);
        },
        [onChange]
    );

    return {
        value,
        handleChange,
    };
};
